import React, { useContext, useEffect, useRef } from "react";
import useRefsInit from "../hooks/useRefsInit.jsx";
import BryntumContext from "../context/bryntumContext.jsx";
import { callOnLoadOnColumns } from "../../other/utils/otherUtils.jsx";
import ResourcesGridView from "../components/ResourcesGridView.jsx";
import {swivuCheckGridGrants} from "../../other/utils/utils.jsx";
import AuthContext from "../context/authContext.jsx";
import SwivuSearchBar from "../components/SwivuSearchBar.jsx";
import AlertNotificationBanner from "../components/alertNotificationBanner/AlertNotificationBanner.jsx";
import useEnableViewTracking from "../hooks/useEnableViewTracking.jsx";
import {VIEW_TYPES} from "../../other/constants/OtherKeys.jsx";
import {GRANTS} from "../../other/constants/PrivilegeTypes.jsx";

const ResourcePage = () => {
  const resourceViewRef = useRef(null);
  const { setRefs, isRefsInit } = useRefsInit([resourceViewRef]);
  const { user } = useContext(AuthContext);
  const { project, editorHandler, stateProvider, viewManager } = useContext(BryntumContext);

  useEnableViewTracking(resourceViewRef, VIEW_TYPES.resources, isRefsInit);

  useEffect(() => {
    if (project) {
      // Assign custom project store to the grid
      if (project.resourceStore) {
        resourceViewRef.current.instance.store = project.resourceStore;
        resourceViewRef.current.instance.store.relayAll(resourceViewRef.current.instance, 'swivuResourceStore');
        resourceViewRef.current.instance.onClickSwivuEditMessage = () => {
          viewManager.openAnonymousViewByType({ viewType: VIEW_TYPES.settings, viewName: 'Settings' });
        }
        swivuCheckGridGrants(resourceViewRef.current.instance, user);
        callOnLoadOnColumns(resourceViewRef.current.instance.columns, project, { editorHandler, user, viewManager });
      }
    }
  }, [resourceViewRef, project, user, editorHandler, viewManager]);

  useEffect(() => {
    if (project?.resourceStore) {
      resourceViewRef.current.instance.onClickSwivuUserEditMessage = () => {
        if (user && user.can(GRANTS.grant_four)) {
          viewManager.selectView(viewManager.getDefaultViewByType(VIEW_TYPES.users));
        }
      }
    }
  }, [project, viewManager]);

  return (
    <>
      <SwivuSearchBar searchableRefs={[resourceViewRef]} />
      {user && (
        <AlertNotificationBanner project={project} editorHandler={editorHandler} stateProvider={stateProvider} user={user} />
      )}
      <ResourcesGridView
        stateId
        ref={setRefs(resourceViewRef)}
        searchFeature={true}
      />
    </>
  );
};

export default ResourcePage;
